define.alias("shared/modifiers/touch-gesture", "settings/modifiers/touch-gesture");